import { useQuery } from "@tanstack/react-query";
import { fetchApi } from "@/lib/api";
import { CLERK_AVAILABLE, getDemoAuthHeaders, getClerkAuthHeaders } from "@/lib/auth";
import { useAuthConditional } from "@/lib/use-auth-conditional";

interface Company {
  id: string;
  name: string;
  createdAt: string;
}

interface User {
  id: string;
  name: string;
  email: string;
}

interface OnboardingStatusResponse {
  hasCompany: boolean;
  company?: Company;
  user?: User;
}

export function useOnboardingStatus() {
  const auth = useAuthConditional();

  return useQuery({
    queryKey: ["onboarding-status"],
    queryFn: async () => {
      const headers = CLERK_AVAILABLE
        ? await getClerkAuthHeaders(auth.getToken)
        : getDemoAuthHeaders();

      return fetchApi<OnboardingStatusResponse>("/api/onboarding/status", {
        headers,
      });
    },
    enabled: auth.isSignedIn,
    staleTime: 1000 * 60 * 5, // 5 minutes
  });
}
